import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { TreeNode } from '../../../data/models/interfaces/tree-node.interface';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss']
})

export class TreeComponent implements OnInit {
  @Input() treeData: TreeNode[] | undefined
  @Output() emitterConfirmEnable  = new EventEmitter<boolean>()
  

  rotation: boolean = false;
  parentChecked: boolean = false;
  childChecked: boolean = false;

  countCheckeds: number = 0

  ngOnInit(): void {
    if (this.treeData != null) {
      this.treeData.forEach(node => {
        if (node.isParent)
          this.checkIfAllChildrenAreChecked(node)
      });
    }
  }

  toggleChild(node: TreeNode) {
    node.showChildren = !node.showChildren
    this.rotation = !this.rotation;
  }

  changeItem(node: TreeNode) {
    this.emitterConfirmEnable.emit(true)
    this.checksParent(node)

    if (!node.isParent && node.parent)
      this.checkIfAllChildrenAreChecked(node.parent)
  }

  enableConfirmButton(evento: boolean){
    this.emitterConfirmEnable.emit(evento)
  }

  private checkIfAllChildrenAreChecked(nodeParent: TreeNode) {
    const isAllChecked = nodeParent.children?.every(x => x.isChecked)
    if (isAllChecked) {
      nodeParent.isChecked = true
    }else{
      nodeParent.isChecked = false
    }
  }

  private checksParent(node: TreeNode) {
    if (node.isChecked && node.children) {
      this.checkAllChildren(node.children)
    }else if (node.children){
      this.uncheckAllChildren(node.children)
    }
  }

  private checkAllChildren(children: TreeNode[]) {
    children.forEach(child => {
      child.isChecked = true
      if (child.children)
        this.checkAllChildren(child.children)
    })
  }

  private uncheckAllChildren(children: TreeNode[]) {
    children.forEach(child => {
      child.isChecked = false
      if (child.children)
        this.uncheckAllChildren(child.children)
    })
  }
}
